var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"counter",style:({width: _vm.counterWidth + 'rem'})},_vm._l((_vm.counterList),function(item){return _c('div',{key:item.id,staticClass:"counter-item"},[_c('img',{style:(_vm.itemStyle),attrs:{"src":item.img,"alt":""}}),_c('span',[_vm._v(_vm._s(item.count))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }